"use client";

import FooterFive from "@/layouts/footers/FooterFive";
import { useEffect, useState } from "react";
import axiosInstance from "@/service/axiosInstance";
import {
  getSortedSectionsWRTType,
  getSortedSectionsWRTpage,
} from "@/utils/utils";
import Loader from "@/components/Loader/Loader";
import { useSearchParams } from "next/navigation";
import { useDispatch } from "react-redux";
import { addFilter } from "@/redux/features/filterSlice";
import LeaderBoardArea from "@/components/leaderboard/LeaderBoardArea";
import LeaderBoardDropdown from "@/components/leaderboard/LeaderBoardDropdown";
import SchoolsRanking from "@/components/leaderboard/SchoolsRanking";
import { ClassificationTypes, emptyFilter } from "@/utils/enum";
import AcademicYearDropdown from "../common/AcademicYearDropdown";

const ListingOne = () => {
  const dispatch = useDispatch();
  const searchParams = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [footerData, setFooterData] = useState([[]]);
  const [socialMedia, setSocialMedia] = useState([]);
  const [selectedOption, setSelectedOption] = useState("All Schools Rankings");

  const getCurrentAcademicYear = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const isAfterApril = today.getMonth() >= 3;
    const startYear = isAfterApril ? currentYear : currentYear - 1;
    return startYear.toString();
  };

  const getAcademicYearOptions = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const isAfterApril = today.getMonth() >= 3;
    const startYear = 2024;
    const endYear = isAfterApril ? currentYear : currentYear - 1;

    const options = [];
    for (let year = startYear; year <= endYear; year++) {
      options.push({
        value: year.toString(),
        label: `${year}-${year + 1}`,
      });
    }

    return options;
  };

  const [academicYear, setAcademicYear] = useState(getCurrentAcademicYear());
  const academicYearOptions = getAcademicYearOptions();

  const getData = async () => {
    try {
      // const token = localStorage.getItem("token");
      setLoading(true);

      const resp: any = await axiosInstance.get("/homePage", {});
      // if (token) {
      //     if (
      //         resp?.isAuthorized?.status == 401 ||
      //         resp?.isAuthorized?.message == "Token has expired"
      //     ) {
      //         console.log("Token has expired!");
      //         toast.error("Session expired please login again", {
      //             position: toast.POSITION.TOP_RIGHT,
      //             autoClose: 3000,
      //         });
      //         localStorage.removeItem("token");
      //         dispatch(logout());
      //     }
      // }

      const footerData1 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 1",
      );

      const footerData2 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 2",
      );

      const footerData3 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 3",
      );
      const socialMediaData = getSortedSectionsWRTpage(
        resp?.data?.data,
        "Social Media",
        "Home Page",
      );
      setSocialMedia(socialMediaData);

      setFooterData([footerData1, footerData2, footerData3]);
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
    console.log("inside leaderboardd");

    return () => {
      dispatch(addFilter(emptyFilter));
    };
  }, []);

  const handleOptionChange = (option: any) => {
    setSelectedOption(option);
    let filters;

    switch (option) {
      case "All Schools Rankings":
        filters = emptyFilter;
        break;
      case "Individual Winners Ranking":
        filters = {
          ...emptyFilter,
          category: ClassificationTypes.Individual,
        };
        break;
      case "Sports Wise Ranking":
        filters = {
          ...emptyFilter,
          eventsType: ["Sports", "Premier Sports"],
          category: ClassificationTypes.Group,
        };
        break;
      default:
        filters = emptyFilter;
    }
    dispatch(addFilter(filters));
  };
  return (
    <>
      {loading && <Loader />}

      <div className="container">
        <div className="row">
          <div
            className="col-12 d-flex justify-content-center justify-content-lg-end"
            style={{ paddingTop: "1rem" }}
          >
            <div className="d-flex flex-column flex-md-row gap-1 align-items-center">
              <LeaderBoardDropdown onOptionChange={handleOptionChange} />
              <AcademicYearDropdown
                options={academicYearOptions}
                value={academicYear}
                onChange={setAcademicYear}
              />
            </div>
          </div>
        </div>
      </div>

      {selectedOption === "All Schools Rankings" && (
        <SchoolsRanking academicYear={academicYear} />
      )}
      {selectedOption === "Individual Winners Ranking" && (
        <LeaderBoardArea academicYear={academicYear} />
      )}
      {selectedOption === "Sports Wise Ranking" && (
        <LeaderBoardArea academicYear={academicYear} />
      )}
      <FooterFive data={footerData} socialMedia={socialMedia} />
    </>
  );
};

export default ListingOne;
